import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=4c054e06&scoped=true"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=4c054e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c054e06",
  null
  
)

export default component.exports